import axiosClient from "./axiosClient";
import { API_ENDPOINTS, API_CREDENTIALS } from "./apiEndpoints";

export const fetchCategories = (has_product_ids) => {
  // Construct query parameters
  // const params = {
  //   list_category_titles_and_ids,
  //   has_product_ids: has_product_ids.join(","), // Convert array to comma-separated string
  // };

  return axiosClient.get(API_ENDPOINTS.GET_CATEGORIES(has_product_ids), {
    headers: {
      apikey: API_CREDENTIALS.API_KEY,
      "secure-business-key": API_CREDENTIALS.SECURE_BUSINESS_KEY,
      apiconnection: "appmobile",
      lang: "en",
    },
  });
};

export const fetchCategoriesAfterBooking = (category_ids) => {
  // Construct query parameters
  // const params = {
  //   list_category_titles_and_ids,
  //   has_product_ids: has_product_ids.join(","), // Convert array to comma-separated string
  // };

  return axiosClient.get(
    API_ENDPOINTS.GET_CATEGORIES_AFTER_BOOKING(category_ids),
    {
      headers: {
        apikey: API_CREDENTIALS.API_KEY,
        "secure-business-key": API_CREDENTIALS.SECURE_BUSINESS_KEY,
        apiconnection: "appmobile",
        lang: "en",
      },
    }
  );
};
